import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./InfoBlock.css";

const InfoBlock = ({ children, className }) => (
	<div className={classNames("Info-Block", className)}>
		{children}
	</div>
);

InfoBlock.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.element),
		PropTypes.element
	]),
	className: PropTypes.string
};

export default InfoBlock;
